import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { OrderPdfButtonComponent } from './ui/order-pdf-button/order-pdf-button.component';
import { OrderPdfDialogComponent } from './ui/order-pdf-dialog/order-pdf-dialog.component';

@NgModule({
  declarations: [OrderPdfButtonComponent, OrderPdfDialogComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatTooltipModule
  ],
  exports: [OrderPdfButtonComponent, OrderPdfDialogComponent]
})
export class OrderPdfModule {}
